/**
 * Debug-Logging Helper
 *
 * Verwendet für Logs, die nur in der Entwicklung sichtbar sein sollen.
 * In Production werden diese Logs komplett unterdrückt.
 *
 * Usage:
 *   import { debugLog } from '@/utils/debugLog';
 *   debugLog('📐 Video AspectRatio ermittelt:', aspectRatio);
 *
 * Für Fehler/Warnungen: Nutze console.error / console.warn direkt
 * oder das zentrale Logger-Utility (src/lib/logger.ts)
 */

const isDev = import.meta.env.DEV;

/**
 * Debug-Log: Nur in Development sichtbar
 * Verwendet für detaillierte Entwicklungs-Informationen
 */
export function debugLog(...args: unknown[]): void {
  if (!isDev) return;

  console.debug(...args);
}
